import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Disclosure } from "../../../components/Disclosure";
import { ComunicacionAjax } from "../../../ts/api/comunicacion";
import { Constantes } from "../../../ts/constantes";
import "./SincroAlmacen.scss";
import { useMemo, useState } from "react";
import { ModalLogsSincro } from "./components/ModalLogSincro";
import { notificacion, notificacionError } from "../../../components/Alerts";
import { createColumnHelper } from "@tanstack/react-table";
import { TypedTable } from "../../../components/TypedTable";
import { Loading, QueryError } from "../../../components/Loading/Loading";

export function SincroAlmacenPage() {
	const [modalShown, setModalShown] = useState(false);
	const [almacen, setAlmacen] = useState<number>(1);
	const [syncFilter, setSyncFilter] = useState<"todos" | "no-sincronizados">("no-sincronizados");

	return (
		<div id="content" className="content" >
			<title>Almacen | Sincronizar Almacén </title>
			<div className="row">
				<div className="col-lg-12">
					<div className="page-header">
						<h2>Panel de sincronización de almacén</h2>
						<ol className="breadcrumb">
							<li className="active">Sincronizar</li>
						</ol>
						<div style={{ float: "right" }}>
							<button className="btnPrimary" onClick={() => setModalShown(true)} type="button">
								Ver logs
							</button>
						</div>
					</div>
				</div>
			</div>

			<Disclosure style={{ marginBottom: 20 }}>
				<h4 className="panel-title panel-heading senalar">
					Filtro
				</h4>
				<FiltroSincro
					almacen={almacen}
					setAlmacen={setAlmacen}
					syncFilter={syncFilter}
					setSyncFilter={setSyncFilter}
				/>
			</Disclosure>

			<div className="table-responsive">
				<TablaStockArticulos
					idAlmacen={almacen}
					syncFilter={syncFilter}
				/>
			</div>

			<ModalLogsSincro show={modalShown} close={() => setModalShown(false)} />
		</div>
	);
}

function FiltroSincro(props: { readonly almacen: number, readonly setAlmacen: (almacen: number) => void; readonly syncFilter: "todos" | "no-sincronizados"; readonly setSyncFilter: (syncFilter: "todos" | "no-sincronizados") => void; }) {

	// $("#comboAlmacenes").on("change", function () {
	// 	const xalmacen_id = $("#comboAlmacenes").val() as string;
	// 	void getStockArticulos(xalmacen_id);
	// });

	const { data, error, isPending } = UseAlmacenes();

	if (error) return <QueryError error={error} fallback="Error cargando los almacenes." />;
	if (isPending) return <Loading />;



	return (
		<div style={{ padding: 30 }} role="tabpanel">
			<label>Almacen: </label>
			<select className="form-control limpiar" value={props.almacen} onChange={e => props.setAlmacen(Number(e.target.value))}>
				{data.data.map((almacen) => (
					<option key={almacen.id} value={almacen.id}>{almacen.id} - {almacen.nombre}</option>
				))}
			</select>

			<br />

			<label>Sincronizados: </label>
			<select className="form-control limpiar" value={props.syncFilter} onChange={e => props.setSyncFilter(e.target.value as "todos" | "no-sincronizados")}>
				<option value="no-sincronizados">No Sincronizados</option>
				<option value="todos">Todos</option>
			</select>
		</div>
	);
}

interface TablaStockArticulosProps {
	readonly idAlmacen: number;
	readonly syncFilter: "todos" | "no-sincronizados";
}
function TablaStockArticulos(props: TablaStockArticulosProps) {
	const { data, error, isPending } = UseStock(props.idAlmacen);

	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<LineaStocksArticulo>();

		const getBtnEKON = (row: LineaStocksArticulo) => <BtnSincro tipo="EKON" rowData={row} idAlmacen={props.idAlmacen} />;
		const getBtnMySQL = (row: LineaStocksArticulo) => <BtnSincro tipo="MYSQL" rowData={row} idAlmacen={props.idAlmacen} />;

		return [
			columnHelper.accessor(row => `${row.idArticulo} - ${row.nombreArticulo}`, { header: "Articulo", meta: { className: "dt-center", style: { width: "30%" } } }),
			columnHelper.accessor("lote", { header: "Lote", meta: { className: "dt-center", style: { width: "10%" }, hidden: !Constantes.existenLotes } }),

			columnHelper.accessor("stockERP", { header: "Cantidad ERP", meta: { className: "dt-right", style: { width: "15%" } }, cell: info => info.getValue() ?? "-" }),
			columnHelper.display({ id: "sincroEkon", header: "", meta: { className: "dt-left", style: { width: "15%" } }, cell: ({ row }) => getBtnEKON(row.original) }),

			columnHelper.accessor("stockMySQL", { header: "Cantidad Almacén", meta: { className: "dt-right", style: { width: "15%" } }, cell: info => info.getValue() ?? "-" }),
			columnHelper.display({ id: "sincroMysql", header: "", meta: { className: "dt-left", style: { width: "15%" } }, cell: ({ row }) => getBtnMySQL(row.original) })
		];
	}, [props.idAlmacen]);


	const dataFiltrado = useMemo(() => {
		if (props.syncFilter === "no-sincronizados")
			return data?.filter(s => s.stockERP != s.stockMySQL);
		else
			return data;
	}, [data, props.syncFilter]);

	if (error) return <QueryError error={error} fallback="Error cargando los usuarios." />;
	if (isPending) return <Loading />;





	return (
		<TypedTable
			className="dataTable display"
			columns={columns}
			data={dataFiltrado!}

			globalSearch
			pagination
			rowClassName={(data) => {
				if (data.stockERP != data.stockMySQL) {
					return "no-sincronizado";
				} else {
					return "sincronizado";
				}
			}}
		/>
	);
}
function BtnSincro(props: { readonly tipo: DBPrioritaria, readonly rowData: LineaStocksArticulo, readonly idAlmacen: number; }) {
	const { tipo, rowData, idAlmacen } = props;
	const queryClient = useQueryClient();
	const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();

		const tipoFormateado = tipo == "EKON" ? "ERP" : "MRP";
		const confirmado = window.confirm(`¿Está seguro de que desea sincronizar el artículo ${rowData.idArticulo}-${rowData.nombreArticulo} con preferencia en ${tipoFormateado}?`);
		if (!confirmado) return;

		void ComunicacionAjax.sendAjaxRequest<RespuestaSync>("POST", "/api/v1/sincronizarAlmacen", {
			prioritaria: tipo,
			idArticulo: rowData.idArticulo,
			lote: rowData.lote,
			idAlmacen: idAlmacen,
		}).then(res => {
			if (res.status != "success") {
				notificacionError(res.message ?? "Error al sincronizar el artículo");
				void queryClient.invalidateQueries({ queryKey: ["getStockAlmacen", idAlmacen] });
				return;
			}

			notificacion("Sincronizado correctamente");
			const prevData = queryClient.getQueryData<LineaStocksArticulo[]>(["getStockAlmacen", idAlmacen]);
			if (prevData) {
				const newData = prevData.map(item => {
					if (item.idArticulo === rowData.idArticulo) {
						if (tipo === "EKON") return { ...item, stockMySQL: rowData.stockERP };
						else return { ...item, stockERP: rowData.stockMySQL };
					}
					return item;
				});
				queryClient.setQueryData(["getStockAlmacen", idAlmacen], newData);
			} else {	//Si podemos usar los datos previos, los actualizamos en cache sin necesidad de recargar, que es una peticion pesada
				void queryClient.invalidateQueries({ queryKey: ["getStockAlmacen", idAlmacen] });
			}
			void queryClient.invalidateQueries({ queryKey: ["getLogsCab"] });
		});
	};


	return <button type="button" className="main-color btnIcon" onClick={onClick}>
		<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" height="30px" viewBox="0 0 16 16">
			<g fill="white">
				<path d="M7.84 4.1a.178.178 0 0 1 .32 0l.634 1.285a.18.18 0 0 0 .134.098l1.42.206c.145.021.204.2.098.303L9.42 6.993a.18.18 0 0 0-.051.158l.242 1.414a.178.178 0 0 1-.258.187l-1.27-.668a.18.18 0
					 0 0-.165 0l-1.27.668a.178.178 0 0 1-.257-.187l.242-1.414a.18.18 0 0 0-.05-.158l-1.03-1.001a.178.178 0 0 1 .098-.303l1.42-.206a.18.18 0 0 0 .134-.098z"></path>
				<path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z"></path>
			</g>
		</svg>
	</button>;
}

function UseStock(idAlmacen: number) {
	return useQuery<LineaStocksArticulo[]>({
		queryKey: ["getStockAlmacen", idAlmacen],
		queryFn: () => {
			const url = "/getStockAlmacen";
			return ComunicacionAjax.sendAjaxRequest<LineaStocksArticulo[]>("GET", url, { "idAlmacen": idAlmacen });
		},
	});
}

function UseAlmacenes() {
	return useQuery<{ data: Almacen[]; }>({
		queryKey: ["getAlmacenes"],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<{ data: Almacen[]; }>("GET", "/api/v1/getAlmacenes");
		},
	});
}


export type DBPrioritaria = "EKON" | "MYSQL";

interface LineaStocksArticulo {
	idArticulo: string;
	nombreArticulo: string;
	gestionaLotes: boolean;
	lote: string;
	stockERP: number | null;
	stockMySQL: number | null;
}
interface Almacen {
	id: number,
	nombre: string;
}

interface RespuestaSync {
	status: "success" | "error";
	message?: string;
}